<template>
  <div class="cart__pack">
    <div class="preview_container">
      <div class="front" v-show="!reverse">
        <part v-for="part in cart.parts" :key="'part_'+part.id" :part="part" :reverse="0"></part>
        <letter v-for="letter in cart.letters" :key="'letter_'+letter.id" :letter="letter" :reverse="0"></letter>
      </div>
      <div class="back" v-show="reverse">
        <part v-for="part in cart.parts" :key="'part_'+part.id" :part="part" :reverse="1"></part>
        <letter v-for="letter in cart.letters" :key="'letter_'+letter.id"  :letter="letter" :reverse="1"></letter>
      </div>
    </div>
    <div class="cart__detail">
      <div class="cart__detail__column">
        <div class="cart__detail__column__key">商品名</div>
        <div class="cart__detail__column__val">{{ cart.category.name | stripTags }}</div>
      </div>
      <div class="cart__detail__column">
        <div class="cart__detail__column__key">サイズ</div>
        <div class="cart__detail__column__val">
          <select class="size" :value="pack.size_id" @input="inputSize($event, pack)">
            <option v-for="(size, index) in sizes" :value="size.id" :key="'size_' + index" :checked="pack.size_id === size.id">
              {{size.name}}
            </option>
          </select>
        </div>
      </div>
      <div class="cart__detail__column">
        <div class="cart__detail__column__key">数量</div>
        <div class="cart__detail__column__val">
          <select class="value" :value="pack.value" @input="inputValue($event, pack)">
            <option v-for="n in 99" :value="n" :key="'val_' + n">{{n}}</option>
          </select>
        </div>
      </div>
      <div class="cart__detail__column">
        <div class="cart__detail__column__key">価格</div>
        <div class="cart__detail__column__val">{{ (cartStockBasePrice(cart) + cartStockPackAddPrice(pack)) * this.pack.value | currency }}</div>
      </div>

      <div class="buttons">
        <button class="reverse" @click="reverse=!reverse">反転</button>
        <button @click="clickEdit">修正</button>
        <button @click="openModal">削除</button>
      </div>
    </div>
  </div>
</template>

<script>
  import modal from '../../service/modal';
  import Part from '../preview/Part.vue';
  import Letter from '../preview/Letter.vue';
  import {mapGetters} from 'vuex';
  export default {
    name: 'CartPack',
    components: {
      Part, Letter
    },
    props: ['pack', 'cart'],
    data(){
      return {
        reverse: false,
      }
    },
    created () {
      if (this.figure_id != this.cart.figure.id){
        // this.sizes = [];
        if (!this.sizes) {
          this.$store.commit('setLoading');
          axios.get('/sizes.json', {params: {figure_id: this.cart.figure.id}})
            .then(response => {
              // this.figure_id = this.cart.figure.id;
              // for (let i = 0; i < response.data.sizes.length; i++) {
              //   this.sizes.push(response.data.sizes[i]);
              // }
              this.$store.commit('setSizes', response.data.sizes);
              this.$store.commit('resetLoading');
            });
        }
      }
    },
    computed:{
      ...mapGetters([
        'designPrice',
        'basePrice',
        'totalPrice',
        'cartStockBasePrice',
        'cartStockPackAddPrice',
      ]),
      sizes () {
        return this.$store.state.sizes.find((sizes, key) => key === this.cart.figure.id);
      }
    },
    methods: {
      inputSize(event) {
        const size_id = event.target.value;
        const selected_size = this.sizes.find(size => size.id === Number(size_id));
        const update_pack = {
          name: this.pack.name,
          number: this.pack.number,
          pack_price: selected_size.add_price,
          size_id: selected_size.id,
          size_name: selected_size.name,
          value: this.pack.value,
        };
        this.$store.commit('setStockCartPack', {
            pack: update_pack,
            index: this.cart.packs.indexOf(this.pack),
            cart: this.cart,
          }
        );
      },
      inputValue(event) {
        const value = event.target.value;
        const update_pack = {
          name: this.pack.name,
          number: this.pack.number,
          pack_price: this.pack.pack_price,
          size_id: this.pack.size_id,
          size_name: this.pack.size_name,
          value: value,
        };
        this.$store.commit('setStockCartPack', {
            pack: update_pack,
            index: this.cart.packs.indexOf(this.pack),
            cart: this.cart,
          }
        );
      },
      openModal () {
        const self = this;
        modal.confirm({
          header: '削除確認',
          message: '選択したアイテムをカートから削除しますか？',
          button: '削除',
          doSomething() {
            self.$emit('remove')
          }
        });
      },
      clickEdit () {
        const cart = this.$store.state.stock_cart.find(stock_cart => stock_cart === this.cart);
        this.$store.commit('setCartJson', cart);
        this.$router.push({name: 'color', params: {
            category_id: cart.category.id,
            figure_id: cart.figure.id,
            design_id: cart.design.id,
          }});
      }
    }
  }
</script>
<style lang="scss" scoped>
  .cart__pack {
    padding: 10px;
    border: 1px solid silver;
    .preview_container {
      float: left;
      width: 50%;
      .front, .back {
        & /deep/ figure{
          margin: 0;
          svg {
            position: relative;
            height: 150px;
          }
        }
        position:relative;
      }
    }
    .cart__detail {
      width: 50%;
      float: right;
      .cart__detail__column{
        padding-right: 1rem;
        clear: both;
        overflow: auto;
        margin-bottom: .3rem;
        line-height: 35px;
        .cart__detail__column__key {
          float: left;
        }
        .cart__detail__column__val {
          float: right;
          select {
            width: 6rem;
          }
        }
      }
      .buttons {
        clear: both;
        margin-top: .6rem;
        button.reverse {
          text-indent:200%;
          white-space:nowrap;
          overflow:hidden;
          background-image: url(http://uni.chapeu.co.jp/src/assets/hanten.svg);
          background-repeat: no-repeat;
          background-size: 100%;
          width: 35px;
          height: 35px;
        }
      }
    }
  }
</style>
